package com.fantasytenis.shared.data.engagement.repository

import com.fantasytenis.shared.core.network.ApiException
import com.fantasytenis.shared.data.engagement.api.EngagementApi
import com.fantasytenis.shared.domain.engagement.EngagementRepository
import com.fantasytenis.shared.domain.engagement.entity.AchievementEntity
import com.fantasytenis.shared.domain.engagement.entity.EngagementEntity

/**
 * Repository implementation for engagement data access.
 */
class EngagementRepositoryImpl(
    private val api: EngagementApi
) : EngagementRepository {

    override suspend fun getMyEngagement(): EngagementEntity {
        val response = api.getMyEngagement()
        if (response.status != 200 || response.data == null) {
            throw ApiException(
                response.error?.type ?: "UNKNOWN",
                response.error?.message ?: "Failed to get engagement data",
                response.status
            )
        }
        return response.data.toEntity()
    }

    override suspend fun getAchievements(): List<AchievementEntity> {
        val response = api.getAchievements()
        if (response.status != 200 || response.data == null) {
            throw ApiException(
                response.error?.type ?: "UNKNOWN",
                response.error?.message ?: "Failed to get achievements",
                response.status
            )
        }
        return response.data.achievements.map { it.toEntity() }
    }

    override suspend fun useStreakSaver(): EngagementEntity {
        val response = api.useStreakSaver()
        if (response.status != 200 || response.data == null) {
            throw ApiException(
                response.error?.type ?: "UNKNOWN",
                response.error?.message ?: "Failed to use streak saver",
                response.status
            )
        }
        return response.data.toEntity()
    }
}
